import { useEffect, useState } from 'react';
import "./newSearchStyle.css";
import { Box } from '@mui/material';
import { useGlobalContext } from '../../../context/GlobalContext';
import { getIcon } from '../../../utils/iconConfig';

const NewSeachBar = ({ type, isOrder , handleClose}) => {
  const { search, setSearch } = useGlobalContext();

  const [text, setText] = useState(search);

  useEffect(() => {
    setText(search);
  }, [search]);

  useEffect(() => {
    if (text === "") {
      setSearch("");
    }
  }, [text]);

  const handleSearch = () => {
    setSearch(text);
    if(type ==="home"){
      handleClose();
    }
  };

  return (
    <>
      <Box
        variant="div"
        className="main-search-outer"
        sx={{
          background: type === "home" ? '#D9D9D9' : "white",
          minWidth: type === "home" ? "30vw" : "21vw",
        }}
      >
        <span>
          {getIcon("Search","grey")}
        </span>
        <input
          type="text"
          autoFocus={!isOrder && true}
          placeholder={type === "home" ? "Search by Design Number" : 'Search By client or Sales person'}
          onChange={(e) => setText(e?.target?.value)}
          onKeyDown={(e) => e?.key === "Enter" &&  handleSearch()}
          value={text}
        />
        <button
          className="main-search-btn"
          style={{
            background: type === "home" ? " #50C878" : "black",
            color: type === "home" ? "black" : "white"

          }}
          onClick={() => (search === "" ? handleSearch() : setSearch(""))}
        >
          {search === "" ? "Search" : "Clear"}
        </button>
      </Box>
    </>
  )
}

export default NewSeachBar